import { render, staticRenderFns } from "./supplement.vue?vue&type=template&id=c44055dc&scoped=true&"
import script from "./supplement.vue?vue&type=script&lang=js&"
export * from "./supplement.vue?vue&type=script&lang=js&"
import style0 from "./supplement.vue?vue&type=style&index=0&id=c44055dc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44055dc",
  null
  
)

export default component.exports